import { createUseStyles } from 'react-jss'

const styles = {
	page: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
	},
}

export default createUseStyles(styles)
